import { render, staticRenderFns } from "./PopulateDataModal.vue?vue&type=template&id=0a10ac50&scoped=true&"
import script from "./PopulateDataModal.vue?vue&type=script&lang=js&"
export * from "./PopulateDataModal.vue?vue&type=script&lang=js&"
import style0 from "./PopulateDataModal.vue?vue&type=style&index=0&id=0a10ac50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10ac50",
  null
  
)

export default component.exports